import { get, patch, post } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";

export const getProjectFieldsDetails = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.siteManagement.getBookingDetailData}`, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getLanguageList = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.preferences.languages}`, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getDateFormatList = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.preferences.dateFormats}`, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getTimeFormatList = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.preferences.timeFormats}`, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getCalenderDaysList = async (project: string | undefined) => {
  try {
    const res = await get(`${ApiUrl.preferences.calenderDays}`, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
